import styled from 'styled-components'

import CardTitle from '../../../../common/styles/CardTitle'
import useTimeOfDayPattern from '../hooks/useTimeOfDayPattern'
import {Chart as ChartJS, CategoryScale, LinearScale, BarElement, Tooltip} from 'chart.js'
import {Bar} from 'react-chartjs-2'
import {useDarkMode} from '../../../../common/hooks/DarkModeContext'
import React from 'react'
import getBarColors from '../utils/getBarColors'

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip)

const BookStatisticsTimeOfDayCard = () => {
	const [data, isLoading] = useTimeOfDayPattern()
	const {isDark} = useDarkMode()
	const chartRef = React.useRef<any>(null)

	const chartValues = data ? [data.morning, data.afternoon, data.evening, data.night] : [0, 0, 0, 0]

	const focusOnGreatest = React.useCallback(() => {
		const chart = chartRef.current
		if (!chart || chartValues.length === 0) return
		const maxIndex = chartValues.lastIndexOf(Math.max(...chartValues))
		if (chartValues[maxIndex] !== 0) {
			chart.tooltip?.setActiveElements([{datasetIndex: 0, index: maxIndex}], {x: 0, y: 0})
			chart.update()
		}
	}, [chartValues])

	React.useEffect(() => {
		focusOnGreatest()
	}, [data])

	return (
		<Container>

				<CardTitle icon={null} mb={0} title={'시간대별 독서 패턴'} url={''} textSize={5}/>

				<ChartContainer onMouseLeave={() => setTimeout(focusOnGreatest, 50)}>
					<Bar
						ref={chartRef}
						data={{
							labels: ['아침 (6-11)', '점심 (12-17)', '저녁 (18-21)', '밤 (22-5)'],
							datasets: [{
								data: chartValues,
								backgroundColor: getBarColors(chartValues),
								borderRadius: 4,
							}],
						}}
						options={{
							animation: isLoading ? false : undefined,
							onHover: (_event, activeElements) => {
								if (activeElements.length === 0) focusOnGreatest()
							},
							plugins: {
								legend: {display: false},
								tooltip: {
									enabled: !isLoading,
									callbacks: {
										label: (context) => `${(context.raw as number).toFixed(1)}%`,
									},
								},
							},
							scales: {
								x: {
									ticks: {color: isDark ? '#AAA' : '#666'},
									grid: {display: false},
								},
								y: {
									beginAtZero: true,
									ticks: {
										color: isDark ? '#AAA' : '#666',
										callback: (value) => `${value}%`,
									},
									grid: {color: isDark ? '#FFFFFF1A' : '#0000001A'},
								},
							},
							maintainAspectRatio: false,
						}}
					/>
				</ChartContainer>

		</Container>
	)
}

const Container = styled.div`
	height: 100%;
	background-color: var(--card-bg-color);
	border-radius: 16px;
	border: 1px solid rgba(0, 0, 0, 0.06);
	box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.04);
	padding: 25px;
`

const ChartContainer = styled.div`
	height: 280px;
`


export default BookStatisticsTimeOfDayCard
